import { useEffect } from 'react';
import SocketApi from '../api/socket';

const useConnectSocket = () => {
  const connectSocket = () => {
    SocketApi.createConnection();
  };

  useEffect(() => {
    connectSocket();
  }, []);
};

export default useConnectSocket;
